import _ from 'lodash';
import moment from 'moment';

export default {
    props: {
        mediaContent: {
            type: Object,
            default: () => {
            },
        },
        haveSubmitRight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isMediaInformationEmpty() {
            return _.isEmpty(this.mediaContent.transcoding_file.media_information);
        },
        isReadySchedules() {
            return this.mediaContent.programs_ready_schedules.length > 0;
        },
        isTranscodingFail() {
            return this.mediaContent.transcoding_state === 'job assigning error' || this.mediaContent.transcoding_state === 'transcoding error';
        },
        isTranscodingDone() {
            return this.mediaContent.transcoding_state === 'transcoding done';
        },
        audioInformation() {
            const defaultAudioInformation = {
                audio_codec: '',
                audio_samplerate: '',
            };
            return this.mediaContent.transcoding_file.media_information.audio ? this.mediaContent.transcoding_file.media_information.audio : defaultAudioInformation;
        },
        videoInformation() {
            const defaultVideoInformation = {
                video_framerate: '',
                video_screen_size: '',
            };
            return this.mediaContent.transcoding_file.media_information.video ? this.mediaContent.transcoding_file.media_information.video : defaultVideoInformation;
        },
        readySchedulesRemainItemCount() {
            return this.mediaContent.programs_ready_schedules.length > 0 ? this.mediaContent.programs_ready_schedules.length - 1 : 0;
        },
        readySchedulesFirstItemStartAt() {
            return this.mediaContent.programs_ready_schedules.length > 0 ? this.mediaContent.programs_ready_schedules[0].start_at : '';
        },
        originFileSize() {
            return this.mediaContent.original_file_size ? this.mediaContent.original_file_size : '';
        },
        transcodingFileSize() {
            return this.mediaContent.transcoding_file_size ? this.mediaContent.transcoding_file_size : '';
        },
        sumFileSize() {
            // 원본 파일 + 트랜스코딩 파일 사이즈
            return this.originFileSize ? this.mediaContent.sum_original_file_and_transcoding_file : this.transcodingFileSize;
        },
        fileSizeTooltip() {
            const tooltip = `
            <div>
                <span style="display:inline-block;width:30px">원본</span>
                <span style="display:inline-block;width:80px;text-align: right">${this.originFileSize}</span>
            </div>
            <div>
                <span style="display:inline-block;width:30px">TR</span>
                <span style="display:inline-block;width:80px;text-align: right">${this.transcodingFileSize}</span>
            </div>
          `;

            return tooltip;
        },
        readySchedulesTooltip() {
            let tooltip = '';
            for (let i = 1; i < this.mediaContent.programs_ready_schedules.length; i++) {
                tooltip += moment(this.mediaContent.programs_ready_schedules[i].start_at).format('YYYY-MM-DD HH:mm:ss');
                if (i < this.mediaContent.programs_ready_schedules.length - 1) {
                    tooltip += '<br>';
                }
            }
            return tooltip;
        },
    },
};
